module.exports = __webpack_public_path__ + "static/media/museosansitalic.8f695be8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/museosansitalic.woff2
// module id = 646
// module chunks = 0